export const LOAD_REQUESTED = "COMBINED_CONTEXT_LOADER/LOAD_REQUESTED";
export const LOAD_SUCCESS = "COMBINED_CONTEXT_LOADER/LOAD_SUCCESS";
export const LOAD_FAIL = "COMBINED_CONTEXT_LOADER/LOAD_FAIL";
export const LOAD_PROGRESS = "COMBINED_CONTEXT_LOADER/LOAD_PROGRESS";

export const LOAD_INSTANCE_REQUESTED = "COMBINED_CONTEXT_LOADER/LOAD_INSTANCE_REQUESTED";
export const LOAD_INSTANCE_SUCCESS = "COMBINED_CONTEXT_LOADER/LOAD_INSTANCE_SUCCESS";
export const LOAD_INSTANCE_FAIL = "COMBINED_CONTEXT_LOADER/LOAD_INSTANCE_FAIL";

// eslint-disable-next-line max-statements
export default (state = {}, { type, data: {
    account,
    instance,
    organisation,
    project,
    workflowinstance,
    error
}={} }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        state.loading = true;
        state.account = null;
        state.instance = null;
        state.organisation = null;
        state.project = null;
        state.workflowinstance = null;
        return state;
    }
    case LOAD_PROGRESS: {
        state.init = false;
        state.account = account || state.account;
        state.instance = instance || state.instance;
        state.organisation = organisation || state.organisation;
        state.project = project || state.project;
        state.workflowinstance = workflowinstance || state.workflowinstance;
        return state;
    }
    case LOAD_SUCCESS: {
        state.init = true;
        state.loading = false;
        state.account = account;
        state.instance = instance;
        state.organisation = organisation;
        state.project = project;
        state.workflowinstance = workflowinstance;
        return state;
    }
    case LOAD_FAIL: {
        state.error = error;
        state.init = true;
        state.loading = false;
        state.account = null;
        state.instance = null;
        state.organisation = null;
        state.project = null;
        state.workflowinstance = null;
        return state;
    }
    case LOAD_INSTANCE_SUCCESS: {
        state.workflowinstance = workflowinstance;
        return state;
    }
    case LOAD_INSTANCE_FAIL: {
        state.error = error;
        state.workflowinstance = null;
        return state;
    }
    default: return state;
    }
};

export const requestLoadCombinedContextLoader = data => ({ type: LOAD_REQUESTED, data });
export const successLoadCombinedContextLoader = data => ({ type: LOAD_SUCCESS, data });
export const progressLoadCombinedContextLoader = data => ({ type: LOAD_PROGRESS, data });
export const failLoadCombinedContextLoader = data => ({ type: LOAD_FAIL, data });

export const requestLoadWorkflowInstance = data => ({ type: LOAD_INSTANCE_REQUESTED, data });
export const successLoadWorkflowInstance = data => ({ type: LOAD_INSTANCE_SUCCESS, data });
export const failLoadWorkflowInstance = data => ({ type: LOAD_INSTANCE_FAIL, data });
